import de from './de.json'
import en from './en.json'

export const dictionaryList = { en, de };

export const languageOptions = {
    "en": "EN",
    "de": "DE"
}